export const HERO_GRID_MAX_ROTATE_Z_OFFSET = 8;

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const getHeroGridRotateZOffset = ({
  clientX,
  left,
  width,
}: {
  clientX: number;
  left: number;
  width: number;
}) => {
  if (width <= 0) {
    return 0;
  }

  const normalizedX = clamp((clientX - left) / width, 0, 1);
  const centeredX = normalizedX * 2 - 1;

  return Number((centeredX * HERO_GRID_MAX_ROTATE_Z_OFFSET).toFixed(2));
};

export const formatHeroGridRotateZOffset = (offset: number) => `${Number(offset.toFixed(2))}deg`;
